export default "__VITE_ASSET__DJwW3ueq__"